/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./Events.css";
import { fetchEvents } from "../../app/slices/eventsSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { oracleDateFormat } from "../../app/utils";
import DateFilter from "../../components/DateFilter/DateFilter";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import EmptyDataContainer from "../../components/EmptyDataContainer/EmptyDataContainer";

const Events = () => {
  const {
    data: eventsList,
    status: statusEvents,
    error: errorEvents,
  } = useSelector(({ events }) => events.get);

  const [formValues, setFormValues] = useState({
    fromDate: moment().subtract(3, "years").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    status: "A",
  });
  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    handleSubmit();
  }, []);

  //methods
  const handleSubmit = () => {
    dispatch(
      fetchEvents({
        start_date: formValues?.fromDate
          ? moment(formValues?.fromDate).format(oracleDateFormat)
          : null,
        end_date: formValues?.toDate
          ? moment(formValues?.toDate).format(oracleDateFormat)
          : null,
        status: formValues?.status,
      })
    );
  };

  //builders
  const BuildListItem = ({ event }) => {
    return (
      <a href={`/events/event-details?id=${event?.event_id}`}>
        <div className="event-item">
          <img
            src={`${process.env.REACT_APP_SERVER_URL}/uploads/events/${event?.cover_image}`}
            alt=""
          />
          <div className="shader">
            <h2>{event?.title}</h2>
            <div className="event-description">{event?.description}</div>
            <small className="mt-5">
              {moment(event.event_date).format("DD-MMM-YYYY")}
            </small>
          </div>
        </div>
      </a>
    );
  };

  return (
    <div className="events app-padding">
      <DateFilter
        formValues={formValues}
        setFormValues={setFormValues}
        handleSubmit={handleSubmit}
      />

      <div className="flex-row flex-wrap mt-30 mb-30">
        {eventsList?.map((event) => (
          <BuildListItem event={event} />
        ))}
      </div>

      {statusEvents === "loading" && (
        <LoadingContainer message={"Loading please wait..."} />
      )}

      {eventsList?.length === 0 && statusEvents === "idle" && (
        <EmptyDataContainer message={"Nothing found"} />
      )}

      {errorEvents && statusEvents !== "loading" && (
        <ErrorContainer
          message={errorEvents?.message}
          onReload={() => {
            handleSubmit();
          }}
        />
      )}
    </div>
  );
};

export default Events;
